import React from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { Link } from 'react-router-dom';
import Badge from '@mui/material/Badge';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { inconList, profileIconList } from '../../driver';
import HomeIcon from '@mui/icons-material/Home';
import CategoryIcon from '@mui/icons-material/Category';
import InfoIcon from '@mui/icons-material/Info';
import CollectionsIcon from '@mui/icons-material/Collections';
import ReviewsIcon from '@mui/icons-material/Reviews';
import CallIcon from '@mui/icons-material/Call';
import BackpackIcon from '@mui/icons-material/Backpack';
import PreviewIcon from '@mui/icons-material/Preview';
import LoginIcon from '@mui/icons-material/Login';
const iconItem = inconList(HomeIcon, CategoryIcon, CollectionsIcon, ReviewsIcon, InfoIcon, CallIcon);


export const DrawerComponent = ({ cartData, email, emailVerified }) => {
    const profileIcons = profileIconList(BackpackIcon, PreviewIcon, LoginIcon, email, emailVerified);
    
    return (
        <div>
            <List>
                <ListItem button>
                    <Link to="/reviewList">
                        <ListItemIcon>
                            <Badge color="secondary" badgeContent={cartData?.length}>
                                <ShoppingCartIcon />{" "}
                            </Badge>
                        </ListItemIcon>
                    </Link>
                    <ListItemText primary={'Cart'} />
                </ListItem>
            </List>
            <Divider />
            <List>
                {
                    iconItem.map((text, index) => (
                        <Link to={text.to} key={text.title} >
                            <ListItem button >

                                <ListItemIcon>
                                    {
                                        <text.icon />
                                    }
                                </ListItemIcon>
                                <ListItemText primary={text.title} />

                            </ListItem>
                        </Link>
                    ))}
                {
                    profileIcons.map((text, index) => (
                        <Link to={text.to} key={text.title} >
                            <ListItem button >

                                <ListItemIcon>
                                    {
                                        <text.icon />
                                    }
                                </ListItemIcon>
                                <ListItemText primary={text.title} />

                            </ListItem>
                        </Link>
                    ))}
            </List>
        </div>
    )
}
